import React, { useState,useRef } from 'react';
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
export function ReceiptModal({ 
    receiptData = null, 
    isOpen = false, 
    onClose = () => {}, 
    title = "Transaction Receipt",
    logoUrl = "http://localhost:3000/assets/images/logo/2.png" 
}) {
   
      

      const handleShare = () => {
        if (navigator.share) {
          navigator
            .share({
              title: "Transaction Receipt",
              text: "Here is your transaction receipt",
              url: window.location.href, // current page or receipt link
            })
            .then(() => console.log("Shared successfully"))
            .catch((error) => console.error("Error sharing", error));
        } else {
          alert("Sharing not supported on this browser.");
        }
      };
      

      const receiptRef = useRef();
      const handlePrint = () => {
        if (!receiptRef.current) {
          console.error("Receipt element not found");
          return;
        }
    
        const printContents = receiptRef.current.innerHTML;
        const newWindow = window.open("", "_blank");
        newWindow.document.write(`
          <html>
            <head>
              <title>Receipt</title>
              <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
            </head>
            <body>${printContents}</body>
          </html>
        `);
        newWindow.document.close();
        newWindow.print();
      };
      // Download Receipt as PDF
      const handleDownload = () => {
        if (!receiptRef.current) {
          console.error("Receipt element not found");
          return;
        }
    
        const element = receiptRef.current;
    
        const opt = {
          margin: 0.5,
          filename: "receipt.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        };
    
        html2pdf().set(opt).from(element).save();
      };

    // Default data structure if no receiptData provided
    const defaultData = {
        id: "N/A",
        txn_id: "N/A",
        operator: "N/A",
        product: "N/A",
        "Opening Balance BC": 0,
        "BC Commission": "0",
        "BC Charge": null,
        "Closing Balance BC": 0,
        number: "N/A",
        amount: "0",
        created_at: "N/A",
        status: "pending",
        commission: "0",
        tds: "0",
        customer: "N/A",
        order_id: "N/A"
    };

    const data = receiptData || defaultData;

    // Helper function to format currency
    const formatCurrency = (amount) => {
        if (!amount || amount === null) return "₹0.00";
        return `₹${parseFloat(amount).toFixed(2)}`;
    };

    // Helper function to get status badge class
    const getStatusClass = (status) => {
        switch(status?.toLowerCase()) {
            case 'success': return 'text-success';
            case 'failed': return 'text-danger';
            case 'pending': return 'text-warning';
            default: return 'text-secondary';
        }
    };

    // Prepare table data from API response
    const tableData = [
        { label: "Transaction ID", value: data.txn_id },
        { label: "Transection", value: data.operator },
        { label: "Product", value: data.product },
        { label: "Customer", value: data.customer },
        { label: "Mobile Number", value: data.number },
        { label: "Amount", value: formatCurrency(data.amount) },

        { label: "Status", value: data.status, isStatus: true },
        
        // { label: "Order ID", value: data.order_id },
        // { label: "Commission", value: formatCurrency(data.commission) },
        // { label: "TDS", value: formatCurrency(data.tds) },
        // { label: "Opening Balance", value: formatCurrency(data["Opening Balance BC"]) },
        // { label: "Closing Balance", value: formatCurrency(data["Closing Balance BC"]) }
    ];

    if (!isOpen) return null;

    return (
        <div 
            className="modal fade show" 
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={onClose}
        >
            <div ref={receiptRef}
                className="modal-dialog modal-fullscreen-md-down" 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header">
                        <h4 className="main-title">{title}</h4>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={onClose}
                        ></button>
                    </div>

                    {/* Modal Body */}
                    <div  className="modal-body p-0">
                        {/* Receipt Container with original styling */}
                        <div className="container invoice-container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <tr>
                                                        <td>
                                                            <table className="table table-lg w-100 invoice-header">
                                                                <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div className="mb-3">
                                                                            <div className="mb-3">
                                                                                {logoUrl ? (
                                                                                    <img 
                                                                                        src={logoUrl} 
                                                                                        alt="Company Logo" 
                                                                                        style={{ width: '200px', height: '60px', objectFit: 'contain' }}
                                                                                    />
                                                                                ) : (
                                                                                    <div style={{
                                                                                        width: '200px',
                                                                                        height: '60px',
                                                                                        backgroundColor: '#007bff',
                                                                                        display: 'flex',
                                                                                        alignItems: 'center',
                                                                                        justifyContent: 'center',
                                                                                        color: 'white',
                                                                                        fontWeight: 'bold',
                                                                                        fontSize: '18px'
                                                                                    }}>
                                                                                        COMPANY LOGO
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <div>
                                                                                <address>
                                                                                    Customer Copy - {data.product} Receipt
                                                                                </address>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="text-end">
                                                                            <div className="mb-1">
                                                                                <h3 className="text-primary">RECEIPT</h3>
                                                                            </div>
                                                                            <p>Receipt <strong>#{data.id}</strong></p>
                                                                            <p><strong>{data.created_at}</strong></p>
                                                                            <p><strong className={getStatusClass(data.status)}>{data.status?.toUpperCase()}</strong></p>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>
                                                            <table className="table table-lg table-bottom-border invoice-table w-100">
                                                                <thead>
                                                                <tr>
                                                                    <th scope="col">Description</th>
                                                                    <th scope="col">Details</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                {tableData.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td style={{ fontWeight: '500' }}>{item.label}</td>
                                                                        <td>
                                                                            {item.isStatus ? (
                                                                                <span className={getStatusClass(item.value)}>
                                                                                    <strong>{item.value?.toUpperCase()}</strong>
                                                                                </span>
                                                                            ) : (
                                                                                item.value
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>

                                                    {/* Note Section */}
                                                    <tr>
                                                        <td>
                                                            <div className="text-center p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                                                                <strong>Note:</strong> Please do not pay any charges/fee
                                                                <br />
                                                                <small className="text-muted">
                                                                    This is a computer generated receipt. No signature required.
                                                                </small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="invoice-footer float-end mb-3">
                                        <button 
                                            className="btn btn-primary rounded m-1" 
                                            onClick={handlePrint} 
                                            type="button"
                                        >
                                            <i className="iconoir-printer"></i> Print
                                        </button>
                                        <button 
                                            className="btn btn-secondary rounded m-1" 
                                            onClick={handleShare}
                                            type="button"
                                        >
                                            <i className="iconoir-send"></i> Send Receipt
                                        </button>
                                        <button 
                                            className="btn btn-success rounded m-1" 
                                            onClick={handleDownload}
                                            type="button"
                                        >
                                            <i className="iconoir-download"></i> Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Example usage component
function ReceiptPageExample() {
    const [showModal, setShowModal] = useState(false);
    const [receiptData, setReceiptData] = useState(null);

    // Simulate API call
    const fetchReceiptData = async () => {
        // This would be your actual API call 
        const apiResponse = {
            "data": {
                "id": 24624,
                "txn_id": "3193433",
                "operator": "Cash Withdrawl",
                "product": "AEPS",
                "Opening Balance BC": 680.02,
                "BC Commission": "6.44644",
                "BC Charge": null,
                "Closing Balance BC": 387.47,
                "number": "6394856756",
                "amount": "100",
                "created_at": "23 October, 2025, 01:10 PM",
                "status": "success",
                "commission": "6.44644",
                "tds": "0.13156",
                "customer": "Rohit Murya",
                "order_id": "1092809909"
            },
            "mtype": "success"
        };
        
        setReceiptData(apiResponse.data);
        setShowModal(true);
    };

    return (
        <div className="p-4">
            <h2>Receipt Example</h2>
            
            {/* Button to trigger receipt modal */}
            <button 
                className="btn btn-primary me-2" 
                onClick={fetchReceiptData}
            >
                View Receipt with API Data
            </button>

            <button 
                className="btn btn-secondary" 
                onClick={() => setShowModal(true)}
            >
                View Receipt without Data
            </button>

            {/* Reusable Receipt Modal */}
            <ReceiptModal
                receiptData={receiptData}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                title="Transaction Receipt"
                logoUrl="http://localhost:3000/assets/images/logo/2.png" // You can pass your logo URL here
            />
        </div>
    );
}

export default ReceiptPageExample;